export async function downloadNodeAsPdf(node, fileName = "export.pdf", opts = {}) {
  const { returnBase64 = false } = opts;
  await ensureLibs();
  const canvas = await window.html2canvas(node, { backgroundColor: "#ffffff", scale: 2, useCORS: true, logging: false });
  const imgData = canvas.toDataURL("image/png");
  const { jsPDF } = window.jspdf;
  const pdf = new jsPDF("p", "pt", "a4");
  const pageW = pdf.internal.pageSize.getWidth();
  const imgW = pageW - 40;
  const imgH = (canvas.height * imgW) / canvas.width;
  pdf.addImage(imgData, "PNG", 20, 20, imgW, imgH, undefined, "FAST");
  if (returnBase64) return { pdfBase64: pdf.output("datauristring").split(",")[1] };
  pdf.save(fileName);
}
async function ensureLibs() {
  if (!window.html2canvas) await load("https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js");
  if (!window.jspdf) await load("https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js");
}
function load(src) {
  return new Promise((res, rej) => { const s = document.createElement("script"); s.src = src; s.async = true; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
}
